export default [
    {
      path: '/rent/v2/my-coupon',
      name: 'myCoupon',
      component: () => import('@/pages/coupon/myCoupon'),
      meta: { title: '优惠券', requireAuth: true },
    },
    {
      path: '/rent/v2/member-rights',
      name: 'memberRights',
      component: () => import('@/pages/coupon/memberRights'),
      meta: { title: '权益领取', requireAuth: true },
    },
    {
      path: '/rent/v2/get-coupons',
      name: 'getCoupons',
      component: () => import('@/pages/coupon/getCoupons'),
      meta: { title: '领券中心', requireAuth: true },
    }
  ]


// WEBPACK FOOTER //
// ./src/pages/coupon/coupon.js